import RecipeService from "./recipe-service";
import UserService from "./user-service";

export default {
  recipe: RecipeService,
  user: UserService
};
